import Application from "../../Application";
import LegalViewCreationPresenter, {
  ILegalViewCreationPresenter
} from "../presenter/LegalViewCreationPresenter";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";

export default class ShowLegalViewCreationInteractor {
  private application: Application;
  private output?: ILegalViewCreationPresenter;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getReferenceLists() {
    return Promise.all([this.getAllOrganisations()]);
  }
  execute() {
    this.output = LegalViewCreationPresenter({
      application: this.application,
      initialState: {
        organisations: [],
        selectedOrganisationId: NaN,
        legalViewTypes: [],
        organisationIndexes: []
      }
    });

    this.getReferenceLists().then(([organisations]) =>
      this.output?.loadReferenceValues(organisations)
    );
    return this.output;
  }
}
